import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VisualizationModeBridgeService {
  private handler: ((mode: string | undefined, toggle?: boolean, deactivate?: boolean) => void) | null = null;

  register(handler: (mode: string | undefined, toggle?: boolean, deactivate?: boolean) => void): void {
    this.handler = handler;
  }

  requestChange(mode: string | undefined, toggle?: boolean, deactivate?: boolean): void {
    this.handler?.(mode, toggle, deactivate);
  }
}
